import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { AdminMessage, Routes } from "../../_components";
import { userConstants } from "../../_constants";
import "../../assets/css/requestEduStatus.css";
import { formatDate } from "../../_helpers/formatDate";
import { CardSelect } from "../../_components/pdp-card-select";
import { Banner, Item, ItemEmpty, List } from "../../_components/ListSnjob";
import { ModalSnjob } from "../../_components/ModalSnjob";
import { pdpStatus } from "../../_helpers/pdp-status";
import { BtnRound } from "../../_components/BtnRound";

class RequestEduStatusSupervisor_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titles: [],
      requested_courses: [],
      detailModal: false,
      activeDetail: 0,
      activeCourse: 0,
      commentModal: false,
    };
    this.globalStorage = this.props.globalStorage;
  }

  componentDidMount() {
    const hasCode3015 = JSON.parse(localStorage.getItem("globalStorage"))
      .value.access.flatMap(({ access_code }) => access_code?.split("-") ?? [])
      .includes("3015");
    if (!hasCode3015) {
      userActions.failure("برای شما در این بخش دسترسی تعریف نشده است");
      this.props.history.push("/pdpSites");
    } else {
      this.getTitles();
      this.getRequestedCourses();
      document.querySelector(".wave").classList.add("hidden");
    }
  }

  componentWillUnmount = () => {
    document.querySelector(".wave").classList.remove("hidden");
  };

  goBack = () => {
    this.props.history.goBack();
  };

  getTitles = () => {
    this.props
      .dispatch(
        userActions.API("get", `v1/user/hospital/course/titles`, null, true)
      )
      .then((res) => {
        this.setState({ titles: res.data });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getRequestedCourses = (job_group = null, post_name = null) => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `${
            userConstants.SERVER_URL
          }v1/user/hospital/supervisor/requested_courses?type=history${
            job_group ? `&job_group=${job_group}` : ""
          }${post_name ? `&post_name=${post_name}` : ""}`
        )
      )
      .then((res) => {
        this.setState({ requested_courses: res.data });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  render() {
    const {
      titles,
      requested_courses,
      detailModal,
      activeDetail,
      commentModal,
      activeCourse,
    } = this.state;
    if (requested_courses.length === 0) return null;

    const superiorComment = requested_courses[activeDetail]
      ? requested_courses[activeDetail].requested_courses[activeCourse]
          .superior_comment
      : null;
    const supervisorComment = requested_courses[activeDetail]
      ? requested_courses[activeDetail].requested_courses[activeCourse]
          .supervisor_comment
      : null;
    const userComment = requested_courses[activeDetail]
      ? requested_courses[activeDetail].requested_courses[0].user_comment
      : null;

    const superior_description = requested_courses[activeDetail]
      ? requested_courses[activeDetail].requested_courses[0]
          .superior_description
      : null;

    const supervisor_description = requested_courses[activeDetail]
      ? requested_courses[activeDetail].requested_courses[0]
          .supervisor_description
      : null;

    const submitted_at = requested_courses[activeDetail]
      ? requested_courses[activeDetail].requested_courses[0].submitted_at
      : null;
    const superior_submitted_at = requested_courses[activeDetail]
      ? requested_courses[activeDetail].requested_courses[0]
          .superior_submitted_at
      : null;
    const supervisor_submitted_at = requested_courses[activeDetail]
      ? requested_courses[activeDetail].requested_courses[0]
          .supervisor_submitted_at
      : null;
    const superior = requested_courses[activeDetail]
      ? requested_courses[activeDetail].requested_courses[0].superior
      : null;
    const { firstname, lastname } = superior;
    const user = requested_courses[activeDetail].user;
    const dates = [
      submitted_at,
      superior_submitted_at,
      supervisor_submitted_at,
    ];
    const names = [
      `درخـواست کننده نیاز آموزشی (${user.firstname} ${user.lastname})`,
      `مافــوق (${firstname} ${lastname})`,
      "سـازمــان",
    ];
    const labels = [
      `${user.firstname} ${user.lastname}`,
      `${firstname} ${lastname}`,
      "سـازمــان",
    ];

    return (
      <div className="requestEduStatus bg-light bg-drr pt-3 pb-5 px-3">
        <Routes page="pdp/requestEduStatus" />
        <div className="container-fluid">
          <div className="card bg-white shadow text-center border-0">
            <AdminMessage />
          </div>
        </div>
        <br />
        <NotifCard text1="وضعیت نیازسنجی های درخواستی در بیمارستان سازمان" />
        <br />
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12 col-lg-9 col-md-12 m-auto">
              <List
                className="transparent-scroll container-fluid px-0"
                style={{ height: "67vh" }}
              >
                <ul
                  className="list position-relative w-100 m-0 p-2"
                  style={{
                    boxShadow: "none",
                  }}
                >
                  <Banner
                    className="py-3"
                    grid="1fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 3fr 2fr"
                    key={0}
                  >
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      ردیف
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      نام
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      نام خانوادگی
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      تاریخ درخواست
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      تاریخ اعمال نظر
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      سمت
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      گروه شغلی
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      بخش
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      وضعیت
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      مشاهده وضعیت
                    </div>
                  </Banner>
                  {requested_courses.length && titles.length ? (
                    requested_courses.map((request, i) => {
                      const { user, requested_courses } = request;
                      const { firstname, lastname, post } = user;
                      const { job_group, name, job_location } = post;
                      const { submitted_at, created_at, status } =
                        requested_courses[0];

                      const statusText =
                        status === "superior_pending"
                          ? "در انتظار تایید توسط شما"
                          : status === "supervisor_pending"
                          ? "در انتظار بررسی توسط سازمان"
                          : status === "rejected_by_superior"
                          ? "در انتظار تایید توسط سازمان"
                          : status === "active"
                          ? "بررسی شده توسط سازمان"
                          : status === "rejected_by_supervisor" ||
                            status === "active"
                          ? "بررسی شده توسط سازمان"
                          : "xxx";
                      const jobGroupText = job_group
                        ? job_group.length > 20
                          ? job_group.slice(0, 20) + "..."
                          : job_group
                        : "گروه شغلی ندارید";
                      const jobLocationText = job_location
                        ? job_location.length > 20
                          ? job_location.slice(0, 20) + "..."
                          : job_location
                        : "بخش ندارید";

                      return (
                        <Item
                          className="py-1"
                          grid="1fr 2fr 2fr 2fr 2fr 2fr 2fr 2fr 3fr 2fr"
                          key={i + 1}
                        >
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0 iran-sans-imp">
                              {i + 1}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {firstname}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {lastname}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0 iran-sans-imp">
                              {formatDate(created_at)}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0 iran-sans-imp">
                              {formatDate(submitted_at)}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {name}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {jobGroupText}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {jobLocationText}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {statusText}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <BtnRound
                              className="detail-icon"
                              onClick={() =>
                                this.setState({
                                  activeDetail: i,
                                  detailModal: true,
                                })
                              }
                            />
                          </div>
                        </Item>
                      );
                    })
                  ) : (
                    <ItemEmpty />
                  )}
                </ul>
              </List>
              <ModalSnjob
                title={`${requested_courses[activeDetail].user.firstname} ${
                  requested_courses[activeDetail].user.lastname
                }${
                  requested_courses[activeDetail].user.post.job_group
                    ? ` - ${requested_courses[activeDetail].user.post.job_group}`
                    : ""
                }`}
                className="requestEduStatus"
                isOpen={detailModal}
                onClose={() => this.setState({ detailModal: false })}
              >
                <div
                  className="row mb-4 d-flex justify-content-center align-items-center"
                  style={{ gap: "2rem" }}
                >
                  {userComment && (
                    <CardSelect
                      hideHeader={true}
                      hideTitle={true}
                      style={{
                        height: "20vh",
                        overflow: "scroll",
                        overflowX: "hidden",
                      }}
                      text={userComment}
                      customTitle={
                        <div
                          className="d-flex justify-content-between align-items-center px-3 py-2"
                          style={{ width: "280px" }}
                        >
                          <p className="m-0 text-primary">کاربر</p>
                          <p className="m-0 text-primary iran-sans-imp">
                            {formatDate(submitted_at)}
                          </p>
                        </div>
                      }
                    />
                  )}
                  {superior_description && (
                    <CardSelect
                      hideHeader={true}
                      hideTitle={true}
                      style={{
                        height: "20vh",
                        overflow: "scroll",
                        overflowX: "hidden",
                      }}
                      text={superior_description}
                      customTitle={
                        <div
                          className="d-flex justify-content-between align-items-center px-3 py-2"
                          style={{ width: "280px" }}
                        >
                          <p className="m-0 text-primary">مافوق</p>
                          <p className="m-0 text-primary iran-sans-imp">
                            {formatDate(superior_submitted_at)}
                          </p>
                        </div>
                      }
                    />
                  )}
                  {supervisor_description && (
                    <CardSelect
                      hideHeader={true}
                      hideTitle={true}
                      style={{
                        height: "20vh",
                        overflow: "scroll",
                        overflowX: "hidden",
                      }}
                      text={supervisor_description}
                      customTitle={
                        <div
                          className="d-flex justify-content-between align-items-center px-3 py-2"
                          style={{ width: "280px" }}
                        >
                          <p className="m-0 text-primary">سازمان</p>
                          <p className="m-0 text-primary iran-sans-imp">
                            {formatDate(supervisor_submitted_at)}
                          </p>
                        </div>
                      }
                    />
                  )}
                </div>
                <Timeline dates={dates} names={names} labels={labels} />
                <List
                  className="transparent-scroll"
                  container="container-fluid"
                  padding="px-0"
                  style={{ height: "25vh" }}
                >
                  <ul
                    className="list position-relative w-100 m-0 p-2"
                    style={{
                      boxShadow: "none",
                    }}
                  >
                    <Banner
                      className="py-3"
                      grid="1fr 6fr 1fr 1fr 1fr 5fr 1fr"
                      key={0}
                    >
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        ردیف
                      </div>
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        عنوان نیازسنجی
                      </div>
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        نظر کاربر
                      </div>
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        نظر مافوق
                      </div>
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        نظر سازمان
                      </div>
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        وضعیت
                      </div>
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        کامنت ها
                      </div>
                    </Banner>
                    {requested_courses.length && titles.length ? (
                      requested_courses[activeDetail].requested_courses.map(
                        (request, i) => {
                          const titleObj = titles.find(
                            (title) => title.id === request.course_id
                          );
                          const title = titleObj ? titleObj.title : "xxx";
                          const {
                            userIcon,
                            superiorIcon,
                            supervisorIcon,
                            statusText,
                          } = pdpStatus(request, titles);

                          return (
                            <Item
                              className="py-1"
                              grid="1fr 6fr 1fr 1fr 1fr 5fr 1fr"
                              key={i + 1}
                            >
                              <div
                                className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                style={{ gap: "10px", fontSize: "15px" }}
                              >
                                <p className="itemComp__text text-center text-primary m-0 iran-sans-imp">
                                  {i + 1}
                                </p>
                              </div>
                              <div
                                className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                style={{ gap: "10px", fontSize: "15px" }}
                              >
                                <p className="itemComp__text text-center text-primary m-0">
                                  {title}
                                </p>
                              </div>
                              <div
                                className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                style={{ gap: "10px", fontSize: "15px" }}
                              >
                                <BtnRound className={`${userIcon}-icon`} />
                              </div>
                              <div
                                className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                style={{ gap: "10px", fontSize: "15px" }}
                              >
                                <BtnRound className={`${superiorIcon}-icon`} />
                              </div>
                              <div
                                className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                style={{ gap: "10px", fontSize: "15px" }}
                              >
                                <BtnRound
                                  className={`${supervisorIcon}-icon`}
                                />
                              </div>
                              <div
                                className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                style={{ gap: "10px", fontSize: "15px" }}
                              >
                                <p className="itemComp__text text-center text-primary m-0">
                                  {statusText}
                                </p>
                              </div>
                              <div
                                className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                style={{ gap: "10px", fontSize: "15px" }}
                              >
                                <BtnRound
                                  className={`doctor${
                                    superiorIcon === "dislike" ||
                                    supervisorIcon === "dislike"
                                      ? ""
                                      : "-dark"
                                  }-icon`}
                                  onClick={
                                    superiorIcon === "dislike" ||
                                    supervisorIcon === "dislike"
                                      ? () =>
                                          this.setState({
                                            activeCourse: i,
                                            commentModal: true,
                                            detailModal: false,
                                          })
                                      : ""
                                  }
                                />
                              </div>
                            </Item>
                          );
                        }
                      )
                    ) : (
                      <ItemEmpty />
                    )}
                  </ul>
                </List>
                <button
                  className="btn d-flex justify-content-center mt-2 rounded-pill mx-auto text-center btn_requestEdu empty_btn"
                  onClick={() => this.setState({ detailModal: false })}
                >
                  <p className="m-0 py-2">بازگشت</p>
                </button>
              </ModalSnjob>
              <ModalSnjob
                title="کامنت ها"
                className="requestEduStatus"
                isOpen={commentModal}
                onClose={() =>
                  this.setState({ commentModal: false, detailModal: true })
                }
              >
                {superiorComment ? (
                  <div className="w-100 mt-4 px-4 container_supervisor">
                    <p className=" m-0 w-100 text-right my-2 px-3 text_style">
                      نظر مافوق
                    </p>
                    <Textarea value={superiorComment} onChange={() => ""} />
                  </div>
                ) : (
                  ""
                )}
                {supervisorComment ? (
                  <div className="w-100 mt-4 px-4 container_supervisor">
                    <p className=" m-0 w-100 text-right my-2 px-3 text_style">
                      نظر سازمان
                    </p>
                    <Textarea value={supervisorComment} onChange={() => ""} />
                  </div>
                ) : (
                  ""
                )}

                <button
                  className="btn btn-primary d-flex justify-content-center mt-2 rounded-pill mx-auto text-center btn_requestEdu"
                  onClick={() =>
                    this.setState({ commentModal: false, detailModal: true })
                  }
                >
                  <p className="m-0 py-2">بازگشت</p>
                </button>
              </ModalSnjob>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class NotifCard extends Component {
  render() {
    const { text1, text2, color1 = "#777777", color2 = "#6c00ff" } = this.props;

    return (
      <div className="notif py-3 px-5">
        <p style={{ color: color1, margin: 0 }}>{text1}</p>
        {text2 && (
          <p style={{ color: color2, margin: "10px 0 0 0" }}>{text2}</p>
        )}
      </div>
    );
  }
}

class Textarea extends Component {
  render() {
    return (
      <textarea
        className={`special-textarea ${this.props.className}`}
        placeholder={`${this.props.placeholder || ""}`}
        value={this.props.value || ""}
        onChange={this.props.onChange}
        style={this.props.style}
      />
    );
  }
}

class Timeline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.dates.filter((date) => date !== null).length - 1,
      previous: 0,
    };
  }

  render() {
    const { dates, names, labels } = this.props;
    const { value } = this.state;

    return (
      <div className="row timelineParent">
        <div className="col-xl-12 col-lg-12 col-md-11 col-sm-10 indexSec timeline mx-auto mb-3">
          <div className="border-0 h-100 ">
            <div
              className="card border-0 shadow-smm"
              style={{ borderRadius: "20px" }}
            >
              <div className="card-body" style={{ height: "270px" }}>
                <div
                  style={{
                    width: "100%",
                    height: "100px",
                    margin: "0 auto 70px auto",
                  }}
                >
                  <div className="text-center title">
                    <span>
                      نـوار اعلام وضعیت نیازسنجی هـای درخـواست شـده توسـط شمـا
                    </span>
                  </div>
                  <div className="row">
                    <div className="col-12 py-5 d-flex flex-row-reverse justify-content-center align-items-center gap-sm">
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 0 ? "bg-primary" : "bg-gray"
                          } basic-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 0 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 0 ? "text-primary" : ""
                          }`}
                        >
                          {names[0]}
                        </p>
                      </div>
                      <div
                        className={`line ${value >= 1 ? "line-active" : ""}`}
                      ></div>
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 1 ? "bg-primary" : "bg-gray"
                          } payesh-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 1 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 1 ? "text-primary" : ""
                          }`}
                        >
                          {names[1]}
                        </p>
                      </div>
                      <div
                        className={`line ${value >= 2 ? "line-active" : ""}`}
                      ></div>
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 2 ? "bg-primary" : "bg-gray"
                          } question-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 2 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 2 ? "text-primary" : ""
                          }`}
                        >
                          {names[2]}
                        </p>
                      </div>
                    </div>
                  </div>
                  {dates[value] !== null ? (
                    value === 0 ? (
                      <p className="mb-0 mt-4 text-center">
                        {`درخواست ${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {`ثبت شد .`}
                      </p>
                    ) : value === 1 ? (
                      <p className="mb-0 mt-4 text-center">
                        {`درخواست شما توسط ${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {` بررسی شد.`}
                      </p>
                    ) : (
                      <p className="mb-0 mt-4 text-center">
                        {`درخواست شما توسط ${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {` بررسی شد.`}
                      </p>
                    )
                  ) : (
                    <p className="mb-0 mt-4 text-center">
                      این مرحله هنوز تکمیل نشده است
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const RequestEduStatusSupervisor = connect((state) => ({
  globalStorage: state.globalStorage,
}))(RequestEduStatusSupervisor_);
export { RequestEduStatusSupervisor };
